import React from 'react';

import Button from '@components/ButtonLegacy';
import { subscribe_path } from '@routes';

interface Attachment {
  title: string;
  url: string;
}
interface EventInfoProps {
  attachments: Attachment[];
  headerImageUrl: string;
  offerCode?: string;
}

const EventInfo = ({ attachments, headerImageUrl, offerCode }: EventInfoProps) => {
  const subscribePath = offerCode ? subscribe_path({ offer: offerCode }) : subscribe_path();
  return (
    <div className="my-16 px-16 xs:px-48">
      <div className="mx-auto flex flex-col items-center">
        <div className="my-16">
          <img
            className="block h-auto w-full object-contain object-top"
            src={headerImageUrl}
            role="presentation"
          />
        </div>
        <div className="my-24">
          {attachments.map((attachment) => (
            <div key={attachment.title} className="py-16">
              <Button href={attachment.url} target="_blank" variant="primary" width="medium">
                {attachment.title}
              </Button>
            </div>
          ))}
          <div className="py-16">
            <Button href={subscribePath} variant="primary" width="medium">
              Subscribe to the Information
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventInfo;
